import React from 'react';
import './NumoFeatureVisual.css';

const discounts = [
  { title: 'Offset 7.68 Tax Discount', percent: '7.68%', desc: 'off entire order' },
  { title: 'Christmass 8.55%', percent: '8.55%', desc: 'off entire order' },
  { title: 'Halloween 12.5%', percent: '12.5%', desc: 'off entire order' },
  { title: 'W1KTM3Y2FQOJ', percent: '69.69%', desc: 'off one-time purchase products' },
  { title: 'SR56MFB60YK', percent: '99.99%', desc: 'off one-time purchase products' },
  { title: 'AB9GM41FZGQC', percent: '0.01%', desc: 'off one-time purchase products' },
  { title: '0V1W5HT73M7H', percent: '2.36%', desc: 'off one-time purchase products' },
];

const NumoFeatureVisual = () => {
  return (
    <div className="nfv-bg">
      <div className="nfv-discounts-panel">
        <div className="nfv-header-row">
          <span className="nfv-title">Discounts</span>
        </div>
        <div className="nfv-tabs-row">
          <span className="nfv-tab nfv-tab-active">All</span>
          <span className="nfv-tab">Active</span>
          <span className="nfv-tab">Scheduled</span>
        </div>
        <div className="nfv-table">
          <div className="nfv-table-header">
            <span className="nfv-checkbox"></span>
            <span className="nfv-col-title">Title</span>
          </div>
          {discounts.map((d, i) => (
            <div className="nfv-table-row" key={i}>
              <span className="nfv-checkbox"></span>
              <span className="nfv-discount-info">
                <span className="nfv-discount-title">{d.title}</span>
                <span className="nfv-discount-desc">{d.percent} <span className="nfv-discount-desc-light">{d.desc}</span></span>
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NumoFeatureVisual; 